import React from 'react';
import { ProgramStatus } from '../../types/program';

interface ProgramStatusBadgeProps {
  status: ProgramStatus;
  className?: string;
}

const STATUS_CONFIG: Record<ProgramStatus, { label: string; classes: string }> = {
  draft: {
    label: 'Draft',
    classes: 'bg-grey-100 text-grey-600 dark:bg-grey-800 dark:text-grey-400',
  },
  active: {
    label: 'Published',
    classes: 'bg-success-50 text-success-700 dark:bg-success-900/30 dark:text-success-400',
  },
  disabled: {
    label: 'Disabled',
    classes: 'bg-warning-50 text-warning-700 dark:bg-warning-900/30 dark:text-warning-400',
  },
  archived: {
    label: 'Hidden',
    classes: 'bg-error-50 text-error-700 dark:bg-error-900/30 dark:text-error-400',
  },
};

const ProgramStatusBadge: React.FC<ProgramStatusBadgeProps> = ({ status, className = '' }) => {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.draft;

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-semibold ${config.classes} ${className}`}
      data-testid="program-status-badge"
    >
      {config.label}
    </span>
  );
};

export default ProgramStatusBadge;
